import React, { useRef } from 'react';
import Layout from '../../Layout';
import { Image, Row, Col } from 'react-bootstrap';
import '../css/service.css';
import { useNavigate } from 'react-router-dom';

const services = [
    {
        id: '01',
        title: 'General Contracting',
        desc: '- Sourcing and supply of industrial materials and equipment.\n'
            + '- Materials sourcing, installation, and maintenance.'
    },
    {
        id: '02',
        title: 'Procurement Services',
        desc: '- Sourcing and supply of industrial materials and equipment\n'
            + '- Vendor selection and contract negotiation\n\n'
            + '- Logistics and supply chain management\n'
            + '- Quality assurance and compliance with industry standards'
    }
];

const GeneralProcurement = () => {
    const navigate = useNavigate();


    const navToPage = () => {
        navigate('/contact-us');
    }


    const scrollRef = useRef(null);

    const scroll = (direction) => {
        console.log("i scrolled ", scrollRef.current)
        if (scrollRef.current) {
            const scrollAmount = scrollRef.current.offsetWidth * 0.6; // 60% of container width
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    return (
        <Layout>

            <section className='abt-container'>
                <div className='abt-header'>
                    <Image src="/procurement.jpg" className="d-inline-block  img-fluid wow fadeInDown" data-wow-duration="0.5s" alt="inovative" />

                    <div className='header-content'>
                        <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1s'>General <br /> Procurement</h1>
                        <button onClick={navToPage} className='cta wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>Request Consultation →</button>
                    </div>

                </div>
            </section>

            <section className='child-container serv'>
                <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>We offer General Procurement, providing solutions for clients’ needs.</h1>
            </section>


            <section className='info-container'>
                <div className="servflex">
                    <div className="">
                        <div className="serv-line" />
                    </div>

                    <div className=''>
                        <p className='servParagText wow animate__animated animate__fadeInDown' data-wow-duration='1.5s'>We specialize in sourcing, supplying, and managing essential materials, equipment, and services to ensure seamless project execution and operational efficiency.</p>
                        {/* <br className='hide' /> */}
                    </div>
                </div>
            </section>


            {/* <section className='info-container'>
                <div className='sectionTwo mt-5'>
                    <Image src="/fab.png" className="d-inline-block  img-fluid wow fadeInDown" data-wow-duration="0.5s" alt="inovative" />
                </div>

            </section> */}



            <section className='sectionThree'>
                <div className='serv-container'>
                    <div className='sectionIn'>
                        <div className='sevThreeOne'>
                            <h1 className='wow animate__animated animate__fadeIn' data-wow-duration='1s' style={{ fontWeight: "200" }}>Scope of Supply</h1>
                        </div>
                        <div className='sevThreeTwo'>
                            <div className='d-flex gap-2'>
                                <div onClick={() => scroll('left')} className='social-handle'>
                                    <span>&larr;</span>
                                </div>
                                <div onClick={() => scroll('right')} className='social-handle'>
                                    <span>&rarr;</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="cardParent" ref={scrollRef}>
                        {services.map((svc, i) => {

                            const [firstWord, ...restWords] = svc.title.split(' ');
                            const restTitle = restWords.join(' ');
                            const delay = (i * 0.5).toFixed(1) + 's';

                            return (
                                <div key={svc.id} className="servCard wow animate__animated animate__fadeInRight"
                                    data-wow-delay={delay}>
                                    <div className="servCardContent">
                                        <h3>
                                            {firstWord}
                                            <br />
                                            {restTitle}
                                        </h3>

                                        {svc.desc.split('\n').map((line, idx) => (
                                            <React.Fragment key={idx}>
                                                {line}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                        {/* <p>{svc.desc}</p> */}
                                        <button onClick={navToPage} className="cta">Request Service →</button>

                                        <div className='dflex align-items-end'>
                                            <span className="servCardNumber">{svc.id}</span>
                                        </div>
                                    </div>
                                </div>
                            )

                        })}
                    </div>

                </div>
            </section>



        </Layout>
    );
};

export default GeneralProcurement;